import { Component, OnDestroy, OnInit } from "@angular/core";
import { GlobalApp } from "../../tools/global";
import {
  InteractivesService,
  SubscriptionService,
  SubGroupsService,
} from "../../api/services";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router, ActivatedRoute } from "@angular/router";
import {
  DropDownItem,
  ManagedSubscription,
  SubscriptionsUsersViewModel,
  SubUsers,
  SubInteractReportExportsEx,
  UserTypes,
  SubGroup,
  SubscriptionGroupViewModel,
  UserState,
} from "../../api/models";
import { MatDialog } from "@angular/material/dialog";
import { AddSubscriptionUserDialogComponent } from "../../dialogs/add-subscription-user-dialog/add-subscription-user-dialog.component";
import { DialogResultType } from "../../dialogs/DialogResult";
import { UpdateUserSubscriptionRequest } from "../../api/models/update-user-subscription-request";
import { MessageDialogComponent } from "../../dialogs/message-dialog/message-dialog.component";
import { ConfirmDialogComponent } from "../../dialogs/confirm-dialog/confirm-dialog.component";
import { link } from "fs";
import { UserTypeValue } from "../../api/models-ex/user-type-values";
import {
  TextEditDialogData,
  TextEditDialogComponent,
} from "../../dialogs/text-edit-dialog/text-edit-dialog.component";
import {
  InputEditDialogData,
  InputEditDialogComponent,
} from "../../dialogs/input-edit-dialog/input-edit-dialog.component";
import { Subscription } from "rxjs";

@Component({
  selector: "app-home",
  templateUrl: "./subscriptionmanagement.component.html",
  styleUrls: ["./subscription.component.css"],
})
export class SubscriptionManagementComponent implements OnInit, OnDestroy {
  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false
  };
  userStateSubscription: Subscription = null;

  subscription: SubscriptionsUsersViewModel = {
    addIsAdminstrator: false,
    addIsSupport: false,
    autoRenewPayPal: false,
    addEmailAddress: "",
    maxDesignerUsers: 0,
    maxDashboardUsers: 0,
    maxReportUsers: 0,
    availableDesignerUsers: 0,
    availableDashboardUsers: 0,
    availableReportUsers: 0,
    adminUserIds: "",
    designerUserIds: "",
    dashboardUserIds: "",
    reportUserIds: "",
    buyerUserIds: "",
    consultantUserIds: "",
    areDesignerLicensesAvailable: false,
    areDashboardLicensesAvailable: false,
    areReportLicensesAvailable: false,
    subscriptionAddOnUsers: [],
    enableDomainUsers: false,
    hasUnsubscribed: false,
    paymentMethod: 1,
    subscriberType: 0,
    subscriptionType: 0,
    invoiceManagementViewModel: {
      userId: 0,
      invoiceItems: [],
    },
    packageTypes: [],
    payPalCancelUrl: "",
    subscriberDomain: "",
    subscriptionId: 0,
    subscriptionIds: [],
    subscriptionUsers: [],
    unSubscribedDomainUsers: "",
    xmlaEndPoint: "",
    userManagerCount: 0,
    invoiceManagerCount: 0,
    isApiSubscription: false,
    allowPreFiltering: false,
    isReportSubscription: true
  };

  isLoading: boolean = true;

  subscriptionId: number;

  subUsers: SubUserModel[] = [];
  reportExports: SubInteractReportExportsEx[] = [];

  isUserManager: boolean = false;
  isInvoiceManager: boolean = false;

  noRoleUsers: SubUserModel[] = [];
  designerUsers: SubUserModel[] = [];
  dashboardUsers: SubUserModel[] = [];
  reportUsers: SubUserModel[] = [];
  subGroups: SubscriptionGroupViewModel[] = [];
  selectedGroupId = -1;
  selectedGroup: SubscriptionGroupViewModel = null;

  constructor(
    private route: ActivatedRoute,
    private app: GlobalApp,
    private subscriptionService: SubscriptionService,
    private interactiveService: InteractivesService,
    private subscritpionGroupService: SubGroupsService,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      } else {
        this.route.paramMap.subscribe((params) => {
          this.subscriptionId = parseInt(params.get("subscriptionId"));

          this.loadSubscription();
          this.app.refreshUserState(this.subscriptionService);
        });
      }
    });
  }

  ngOnInit() {
    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      this.userState = userState;
    });
  }

  ngOnDestroy() {
    if (this.userStateSubscription) {
      this.userStateSubscription.unsubscribe();
    }
  }

  subscriptionGroupChanged() {
    if (this.selectedGroupId === -1) {
      this.selectedGroup = null;
    } else {
      this.selectedGroup = this.subGroups.filter(
        (x) => x.subscriptionGroupId === this.selectedGroupId
      )[0];
    }
  }

  userStateChecked() {
    this.subscriptionService
      .subscriptionUpdateSubscriptionGroups(this.subGroups)
      .subscribe((result) => {});
  }

  createGroup() {
    const params: InputEditDialogData = {
      title: "Create Subscription Group",
      prompt: "Group Name",
      data: "",
    };

    const dialogRef = this.dialog.open(InputEditDialogComponent, {
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result !== null &&
        result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        const newGroupName = result.ResultData as string;
        this.subscritpionGroupService
          .subGroupsPostSubGroup({
            subscriptionId: this.subscriptionId,
            subGroup: {
              subscriptionId: this.subscriptionId,
              groupName: newGroupName,
              subscriptionGroupId: undefined,
              deleted: false,
            },
          })
          .subscribe((result) => {
            this.selectedGroupId = result.subscriptionGroupId;
            this.loadSubscritpionGroups();
          });
      }
    });
  }

  deleteGroup() {
    if (this.selectedGroup !== null) {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete",
        "Are you sure you want to delete this group?"
      ).subscribe((result) => {
        if (
          result !== null &&
          result.ResultType !== null &&
          result.ResultType === DialogResultType.Ok
        ) {
          this.subscritpionGroupService
            .subGroupsDeleteSubGroup(this.selectedGroup.subscriptionGroupId)
            .subscribe((result) => {
              this.selectedGroupId = -1;
              this.loadSubscritpionGroups();
            });
        }
      });
    }
  }

  loadSubscritpionGroups() {
    this.subscriptionService
      .subscriptionGetSubscriptionGroups(this.subscriptionId)
      .subscribe((result) => {
        this.subGroups = result;
        this.subscriptionGroupChanged();
      });
  }

  loadSubscription(): void {
    this.app.pushLoading("Loading Subscription");
    this.loadSubscritpionGroups();

    this.subscriptionService
      .subscriptionGetSubscriptionUserViewModel(this.subscriptionId)
      .subscribe(
        (result) => {
          this.subscription = result;

          this.subUsers = [];
          this.noRoleUsers = [];
          this.designerUsers = [];
          this.dashboardUsers = [];
          this.reportUsers = [];

          let noRoleIndex = 1;
          let designerIndex = 1;
          let dashboardIndex = 1;
          let reportIndex = 1;

          for (var i = 0; i < this.subscription.subscriptionUsers.length; i++) {
            let u: SubUserModel = {
              ...this.subscription.subscriptionUsers[i],
              licenseIndex: "",
            };

            if (
              u.userId &&
              u.userId.toString() == localStorage.getItem("id") &&
              u.userManager
            ) {
              this.isUserManager = true;
            }

            if (
              u.userId &&
              u.userId.toString() == localStorage.getItem("id") &&
              u.invoiceManager
            ) {
              this.isInvoiceManager = true;
            }

            switch (u.userType) {
              case UserTypeValue.NoRole:
                {
                  u.licenseIndex = noRoleIndex.toString();
                  noRoleIndex++;
                  this.noRoleUsers.push(u);
                }
                break;
              case UserTypeValue.Designer:
                {
                  u.licenseIndex = designerIndex.toString();
                  designerIndex++;
                  this.designerUsers.push(u);
                }
                break;
              case UserTypeValue.Dashboard:
                {
                  u.licenseIndex = dashboardIndex.toString();
                  dashboardIndex++;
                  this.dashboardUsers.push(u);
                }
                break;
              case UserTypeValue.Report:
                {
                  u.licenseIndex = reportIndex.toString();
                  reportIndex++;
                  this.reportUsers.push(u);
                }
                break;
            }

            this.subUsers.push(u);
          }

          this.app.popLoading();
          this.isLoading = false;
        },
        (error) => {
          var t = 0;
        }
      );
  }

  saveDomainChanges() {}

  removeUser(userToRemove: SubUserModel): boolean {
    if (this.subscription.subscriptionUsers.length == 1) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Can't Delete User",
        "Cannot delete the only user on the subscription"
      );
    } else {
      ConfirmDialogComponent.showDialog(
        this.dialog,
        "Confirm Delete",
        "Are you sure you want to delete this subscription user?"
      ).subscribe((result) => {
        if (result.ResultType == DialogResultType.Ok) {
          const request: UpdateUserSubscriptionRequest = {
            subscriptionId: this.subscriptionId,
            users: [
              {
                delete: true,
                emailAddress: userToRemove.emailAddress,
                userType: 3,
                userManager: userToRemove.userManager,
                invoiceManager: userToRemove.invoiceManager,
              },
            ],
          };

          this.subscriptionService
            .subscriptionUpdateUsersSubscription(request)
            .subscribe((result) => {
              if (result !== "") {
                MessageDialogComponent.showDialog(this.dialog, "Error", result);
              } else {
                this.loadSubscription();
              }
            });
        }
      });
    }

    return false;
  }

  updateUsers() {
    const request: UpdateUserSubscriptionRequest = {
      subscriptionId: this.subscriptionId,
      users: [],
    };

    for (let i = 0; i < this.subUsers.length; i++) {
      request.users.push({
        userType: this.subUsers[i].userType,
        delete: false,
        emailAddress: this.subUsers[i].emailAddress,
        userManager: this.subUsers[i].userManager,
        invoiceManager: this.subUsers[i].invoiceManager,
      });
    }

    this.app.pushLoading("Saving Users");
    this.subscriptionService
      .subscriptionUpdateUsersSubscription(request)
      .subscribe((result) => {
        if (result !== "") {
          MessageDialogComponent.showDialog(this.dialog, "Error", result);
        } else {
          this.loadSubscription();
          this.app.popLoading();
        }
      });
  }

  updateSingleUser(userIndex: number, userType: string): void {

    var subUser: SubUserModel = undefined;

    if(userType === 'NoRole') {
      subUser = this.noRoleUsers[userIndex];
    } else if (userType === 'Designer') {
      subUser = this.designerUsers[userIndex];
    } else if (userType === 'Dashboard') {
      subUser = this.dashboardUsers[userIndex];
    } else if (userType === 'Report') {
      subUser = this.reportUsers[userIndex];
    }
    const request: UpdateUserSubscriptionRequest = {
      subscriptionId: this.subscriptionId,
      users: [],
    };

    if (subUser) {
      request.users.push({
        userType: subUser.userType,
        delete: false,
        emailAddress: subUser.emailAddress,
        userManager: subUser.userManager,
        invoiceManager: subUser.invoiceManager,
      });

      this.subscriptionService
        .subscriptionUpdateUsersSubscription(request)
        .subscribe((result) => {
          if (result !== "") {
            MessageDialogComponent.showDialog(this.dialog, "Error", result);
          } else {
            this.loadSubscription();
          }
        });
    }
  }

  addNewUser() {
    const dialogRef = this.dialog.open(AddSubscriptionUserDialogComponent, {
      width: "500px",
      data: {
        reportOnly: this.subscription.isReportSubscription
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType === DialogResultType.Ok
      ) {
        const request: UpdateUserSubscriptionRequest = {
          subscriptionId: this.subscriptionId,
          users: [
            {
              userType: result.ResultData.userType,
              delete: false,
              emailAddress: result.ResultData.emailAddress,
              userManager: result.ResultData.userManager,
              invoiceManager: result.ResultData.invoiceManager,
            },
          ],
        };

        this.subscriptionService
          .subscriptionUpdateUserSubscription(request)
          .subscribe((result) => {
            if (result !== "") {
              MessageDialogComponent.showDialog(
                this.dialog,
                "Error Adding User",
                result
              );
            } else {
              this.loadSubscription();
            }
          });
      }
    });
  }

  loadReportExports() {
    this.interactiveService
      .interactivesGetReportExportsBySubscription(this.subscriptionId)
      .subscribe((result) => {
        this.reportExports = result;
      });
  }

  deleteExport(reportExport: SubInteractReportExportsEx) {
    ConfirmDialogComponent.showDialog(
      this.dialog,
      "Confirm Delete",
      "Are you sure you want to delete this report?"
    ).subscribe((result) => {
      if ((result.ResultType = DialogResultType.Ok)) {
        this.interactiveService
          .interactivesDeleteReportExport({
            subInteractReportExportId: reportExport.subInteractReportExportId,
            userId: -1
          })
          .subscribe((result) => {
            this.loadReportExports();
          });
      }
    });

    return false;
  }

  downloadExport(reportExport: SubInteractReportExportsEx) {
    if (reportExport.status === 1) {
      this.interactiveService
        .interactivesGetReportExportDownloadUrl(
          reportExport.subInteractReportExportId
        )
        .subscribe((resultUrl) => {
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.setAttribute("style", "display: none");
          a.href = resultUrl;
          a.download = reportExport.fileId + "." + reportExport.fileExt;
          a.click();
          window.URL.revokeObjectURL(resultUrl);
          a.remove();
        });
    }

    return false;
  }

  resendInvitationEmail(user: SubUserModel) {
    this.subscriptionService.subscriptionSendSubscriptionInvitationEmail({
      subscriptionId: this.subscriptionId,
      subUserId: user.subscriptionUserId
    }).subscribe(result=> {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Complete",
        "Invitation Email Re-Sent"
      );
    })
    return false;
  }
}

export interface SubUserModel extends SubUsers {
  licenseIndex: string;
}
